import(/* webpackMode: "eager", webpackExports: ["Root","Indicator","displayName"] */ "/vercel/path0/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Thumb","displayName"] */ "/vercel/path0/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogContent","DialogHeader","DialogTitle","DialogDescription","DialogFooter"] */ "/vercel/path0/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectContent","SelectItem","SelectTrigger","SelectValue"] */ "/vercel/path0/src/components/ui/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleSelect"] */ "/vercel/path0/src/components/ui/simpleSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/src/components/ui/tabs.tsx");
